import { useEffect, useMemo, useState } from "react";
import AddEventFormSuggest from "./Suggest";
import moment from "jalali-moment";
import { useDispatch, useSelector } from "react-redux";

import {
  SET_CAN_I_SEND_DATA_EVENTS,
  SET_ENTERED_DATA_EVENTS,
  SET_FIELDS_EVENTS,
} from "../../../../redux/action/events/eventsType";

import Switch from "../../../UI/Switch";
import Input from "../../../UI/Input";
import AddEventFormCustomTimeListColck from "./CustomTime/List/Clock";
import AddEventFormAlarms from "./Alarms";
import { useLocation } from "react-router-dom";
import Textarea from "../../../UI/Textarea";
import AddEventFormCasesField from "./Cases";
import { ReactSVG } from "react-svg";
import {
  getBaseDataInfoFromLocaleStorage,
  saveBaseDataInfoToLocaleStorage,
} from "../../../../utils/base-data";
import { getBaseDataLawyer } from "../../../../redux/action/baseData/baseAction";
import { SET_SUCCESS_BASEDATA } from "../../../../redux/action/baseData/baseType";
import { useCookies } from "react-cookie";
import { getWalletInfo } from "../../../../redux/action/wallet/action";
import {
  SMS_COST_TOMAN,
  eventWallMoment,
  formatToman,
  normalizeClock,
  resolveAlarms,
} from "../../../../utils/alarms";

const AddEventForm = (props) => {
  const dispatch = useDispatch();
  const enteredData = useSelector((state) => state.events.enteredData);
  const differentDate = useSelector(
    (state) => state.events.computerDifferentTime
  );
  const reciveTimeFromServer = useSelector(
    (state) => state.events.serverDateObject
  );
  const fields = useSelector((state) => state.events.fields);
  const [validationDescription, setValidationDescription] = useState(false);

  // for switch messages
  const baseDataEventSwitchs = useSelector(
    (state) => state.baseData.info?.config?.terms_event
  );
  const baseDataLoading = useSelector((state) => state.baseData.loading);
  const baseDataError = useSelector((state) => state.baseData.error);
  const baseDataLoaded = useSelector((state) => state.baseData.loaded);

  const walletAmount = useSelector((state) => state?.wallet?.wallet?.balance);
  const walletLoading = useSelector((state) => state?.wallet.loading);
  const walletLoaded = useSelector((state) => state?.wallet.loaded);

  const [time] = useState(
    moment(new Date().valueOf() + (differentDate ? differentDate : 0)).format(
      "HH:mm"
    )
  );

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState({});

  const location = useLocation();

  const [cookies] = useCookies(["authToken"]);

  useEffect(() => {
    getSwitchMessagesFromBaseData();
    if (!walletLoaded && !walletLoading) {
      getWalletData();
    }
  }, []);

  useEffect(() => {
    const dateClock = moment(new Date().valueOf() + differentDate).format(
      "HH:mm"
    );

    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        title: { value: "", max: 50, isValid: true, prefix: "" },
        showEventToMovakel: false,
        caseInfo: location?.state?.caseInfo ? location?.state?.caseInfo : {},
        description: { value: "", min: 3, isValid: true },
        alarms: [],
        clock: dateClock,
        sendSms: true,
      },
    });
  }, [differentDate, loaded]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      checkExistError();
    }, 500);

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [fields]);

  const getSwitchMessagesFromBaseData = async () => {
    if (baseDataLoaded) return;

    if (baseDataLoading) return;

    const baseData = getBaseDataInfoFromLocaleStorage();

    if (!baseData) {
      const data = await dispatch(await getBaseDataLawyer(cookies.authToken));

      if (data) {
        saveBaseDataInfoToLocaleStorage(data);
      }
    } else {
      dispatch({
        type: SET_SUCCESS_BASEDATA,
        payload: baseData,
      });
    }
  };

  const getWalletData = async () => {
    await dispatch(await getWalletInfo(cookies.authToken));
  };

  // do a bit work
  const addSuggestToTitleFields = (text) => {
    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        ...fields,
        title: {
          ...fields.title,
          value: text,
          isValid: true,
        },
      },
    });

    dispatch({
      type: SET_ENTERED_DATA_EVENTS,
      payload: true,
    });

    if (error && error.title) {
      delete error["title"];

      setError({
        ...error,
      });
    }
  };

  // direct update fields
  const updateTitleFields = (event) => {
    if (event.target.value.length >= 51) return;

    if (event.target.value.length <= 2) {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          title: {
            ...fields.title,
            value: event.target.value,
            isValid: false,
          },
        },
      });

      setError({
        ...error,
        title: true,
      });

      dispatch({
        type: SET_ENTERED_DATA_EVENTS,
        payload: true,
      });
    } else {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          title: {
            ...fields.title,
            value: event.target.value,
            isValid: true,
          },
        },
      });

      if (error && error.title) {
        delete error["title"];

        setError({
          ...error,
        });
      }
    }
  };

  const updateShowToMovakelField = (value) => {
    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        ...fields,
        showEventToMovakel: value,
      },
    });
  };

  const updateSendSmsField = (value) => {
    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        ...fields,
        sendSms: value,
      },
    });
  };

  const updateDescriptionFields = (event) => {
    if (event.target.value.length > 1500) {
      setValidationDescription(true);
      return;
    } else {
      setValidationDescription(false);
    }

    if (event.target.value.length >= 1 && event.target.value.length <= 2) {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          description: {
            value: event.target.value,
            min: fields.description.min,
            isValid: false,
          },
        },
      });

      setError({
        ...error,
        description: true,
      });
    } else {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          description: {
            value: event.target.value,
            min: fields.description.min,
            isValid: true,
          },
        },
      });

      if (error && error.description) {
        delete error["description"];

        setError({
          ...error,
        });
      }
    }
  };

  const updateCaseInfoField = (id, text) => {
    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        ...fields,
        caseInfo: {
          id,
          text,
        },
      },
    });
  };

  const updateClockField = ({ hour, min }) => {
    if (hour) {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          clock: normalizeClock(`${hour}:${fields.clock.split(":")[1]}`) || fields.clock,
        },
      });
    } else if (min) {
      dispatch({
        type: SET_FIELDS_EVENTS,
        payload: {
          ...fields,
          clock: normalizeClock(`${fields.clock.split(":")[0]}:${min}`) || fields.clock,
        },
      });
    }
  };

  // alarms (each selected alarm becomes its own event on submit)
  const updateAlarms = (alarms) => {
    dispatch({
      type: SET_FIELDS_EVENTS,
      payload: {
        ...fields,
        alarms,
      },
    });
  };

  const eventWall = useMemo(
    () => eventWallMoment(props.englishDate, fields.clock),
    [props.englishDate, fields.clock]
  );

  // sms is charged per alarm event, so the wallet check scales with the count
  const activeAlarmsCount = eventWall
    ? resolveAlarms(fields.alarms, eventWall, Date.now() + (differentDate || 0))
        .length
    : 0;
  const smsRequired = SMS_COST_TOMAN * Math.max(1, activeAlarmsCount);

  const checkExistError = () => {
    if (
      !enteredData ||
      Object.keys(error).length >= 1 ||
      fields.title.value === ""
    ) {
      dispatch({
        type: SET_CAN_I_SEND_DATA_EVENTS,
        payload: false,
      });
    } else {
      dispatch({
        type: SET_CAN_I_SEND_DATA_EVENTS,
        payload: true,
      });
    }
  };

  // const timestamp = 1697796983572 / 1000; // تبدیل به ثانیه

  // const jalaliDate = fromUnixTime(1628620819);
  // const jalaliDates = Date.parse('2021-08-10T18:40:19.000Z') / 1000;

  // console.log(jalaliDate);
  // console.log(jalaliDates);

  return (
    <form className="flex flex-col gap-8">
      <div className="flex flex-col gap-8 rounded-2xl shadow-custom-lg border-[3px] border-white p-4 relative mt-6">
        <div className="rounded-2xl bg-custom-gray w-fit mx-auto left-0 right-0 top-0 absolute -translate-y-1/2 shadow-custom-lg border-[3px] font-medium border-white px-4 p-3 text-gray-700">
          {`${Number(props.persianDate.split("/")[0])
            .toLocaleString("fa")
            .split("٬")
            .join("")}/${
            Number(props.persianDate.split("/")[1]) < 10
              ? "۰" +
                Number(props.persianDate.split("/")[1]).toLocaleString("fa")
              : Number(props.persianDate.split("/")[1]).toLocaleString("fa")
          }/${
            Number(props.persianDate.split("/")[2]) < 10
              ? "۰" +
                Number(props.persianDate.split("/")[2]).toLocaleString("fa")
              : Number(props.persianDate.split("/")[2]).toLocaleString("fa")
          }`}
        </div>

        <div className="md:w-fit md:ml-auto flex flex-col gap-2.5">
          <span className="text-sm text-gray-600"> زمان : </span>

          {fields.clock && reciveTimeFromServer?.year ? (
            <AddEventFormCustomTimeListColck
              time={moment(new Date().valueOf() + differentDate).format(
                "HH:mm"
              )}
              onSetHourOfTime={updateClockField}
              onSetMinOfTime={updateClockField}
            />
          ) : (
            <div className="h-48 w-64 bg-white relative overflow-hidden mx-auto flex items-center justify-between border border-gray-200 rounded-2xl">
              <ReactSVG
                className="w-12 mx-auto text-gray-400"
                src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`}
              />
            </div>
          )}
        </div>

        <div className="grid xm:grid-cols-2 grid-cols-1 gap-8">
          <Input
            id={"event-title"}
            label={"عنوان"}
            max={fields.title.max}
            icon={"title"}
            value={fields.title.prefix + fields.title.value}
            isValid={fields.title.isValid}
            onChange={updateTitleFields}
          />
        </div>

        <AddEventFormSuggest
          onAddToTitle={addSuggestToTitleFields}
          isActivePrefix={fields.title.value}
        />

        <hr />

        <AddEventFormAlarms
          englishDate={props.englishDate}
          clock={fields.clock}
          alarms={fields.alarms || []}
          sendSms={fields.sendSms}
          onChange={updateAlarms}
        />

        <hr />

        <AddEventFormCasesField
          caseInfo={fields.caseInfo}
          onUpdateCaseInfoField={updateCaseInfoField}
          loading={false}
          mainCase={
            props.info && props?.info?.law_suit?.title
              ? {
                  text: props.info.law_suit.title,
                  id: props.info.law_suit.id,
                }
              : null
          }
        />

        <hr />

        <div>
          <Textarea
            rows={4}
            icon={"description"}
            label={"توضیحات"}
            max={1500}
            value={fields.description.value}
            isValid={fields.description.isValid}
            onChange={(event) => updateDescriptionFields(event)}
            loading={false}
          />

          {validationDescription && (
            <p class="text-orange-700 p-2">
              حداکثر تعداد مجاز برای توضیحات، ۱۵۰۰ کاراکتر است.
            </p>
          )}
        </div>

        <hr />

        <div className="grid md:grid-cols-2 grid-cols-1 items-center 3xm:gap-4 gap-5">
          <Switch
            name={"sendSms"}
            title={
              baseDataError ||
              baseDataLoading ||
              !baseDataEventSwitchs?.sms_term
                ? "ارسال پیامک یادآوری در زمان هشدار"
                : baseDataEventSwitchs?.sms_term
            }
            description={
              baseDataError ||
              baseDataLoading ||
              !baseDataEventSwitchs?.sms_term
                ? "با کسر هزینه 400 تومان از کیف پول "
                : baseDataEventSwitchs?.sms_desc
            }
            value={fields.sendSms}
            link="https://api.vakilsun.com/help_sms"
            onUpdateSwitchValue={updateSendSmsField}
          />
        </div>
        {fields.sendSms && walletAmount?.total < smsRequired && (
          <p className="block text-sm text-orange-700">
            {activeAlarmsCount > 1
              ? `موجودی شما برای ارسال پیامک ${activeAlarmsCount.toLocaleString(
                  "fa"
                )} هشدار کافی نیست (نیاز به ${formatToman(smsRequired)})`
              : "موجودی شما برای ارسال پیامک کافی نیست"}
          </p>
        )}
        <hr />

        <div className="grid md:grid-cols-2 grid-cols-1 items-center 3xm:gap-4 gap-5">
          <Switch
            name={"showEventToMovakel"}
            title={
              baseDataError ||
              baseDataLoading ||
              !baseDataEventSwitchs?.event_term
                ? "نمایش رویداد در اپلیکیشن موکل"
                : baseDataEventSwitchs?.event_term
            }
            description={
              baseDataError ||
              baseDataLoading ||
              !baseDataEventSwitchs?.event_desc
                ? " فقط به موکل هایی که مجوز مشاهده دارند. "
                : baseDataEventSwitchs?.event_desc
            }
            value={fields.showEventToMovakel}
            link="https://api.vakilsun.com/help_client_show"
            onUpdateSwitchValue={updateShowToMovakelField}
            loading={false}
          />
        </div>
      </div>
    </form>
  );
};

export default AddEventForm;
